import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import NewsletterSection from "../home/components/NewsletterSection";
import SGHero from "./components/SGHero";
import SGColorSection from "./components/SGColorSection";
import SGMaterialsSection from "./components/SGMaterialsSection";
import SGCalmRoomSection from "./components/SGCalmRoomSection";
import SGMinimalStylingSection from "./components/SGMinimalStylingSection";
import SGBottomCTA from "./components/SGBottomCTA";

export default function StyleGuide() {
  return (
    <div className="bg-[#FAF7F0] min-h-screen">
      <Navbar />
      <SGHero />
      <SGColorSection />
      <SGMaterialsSection />
      <SGCalmRoomSection />
      <SGMinimalStylingSection />
      <SGBottomCTA />
      <NewsletterSection />
      <Footer />
    </div>
  );
}
